import React from 'react'
import './brokerMiFID2DisclaimerForAltFundsDisclaimerItem.scss';
import PropTypes from "prop-types";

const BrokerMiFID2DisclaimerForAltFundsDisclaimerItem = ({ icon, title, children }) => {
    return (
        <div className="broker-mifid2-disclaimer-alt-funds-item">
            <div className="broker-mifid2-disclaimer-alt-funds-item__icon">
                {icon}
            </div>
            <div className="broker-mifid2-disclaimer-alt-funds-item__information">
                <div className="broker-mifid2-disclaimer-alt-funds-item__information-title">{title}</div>
                <div className="broker-mifid2-disclaimer-alt-funds-item__information-content">
                    {children}
                </div>
            </div>
        </div>
    );
};

BrokerMiFID2DisclaimerForAltFundsDisclaimerItem.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default BrokerMiFID2DisclaimerForAltFundsDisclaimerItem;